"use client";
// components/TopBar.tsx

// import { FaBell, FaCog, FaUser } from 'react-icons/fa';
// import { FaBell, FaCog, FaSearch, FaUserCircle } from 'react-icons/fa';
// import { FcInspection } from "react-icons/fc";
import { PiClockClockwiseLight } from "react-icons/pi";
import { HiOutlineUserCircle } from "react-icons/hi2";
import { GoPeople } from "react-icons/go";
import { IoSettingsOutline } from "react-icons/io5";
import { IoIosNotificationsOutline } from "react-icons/io";
import { BsFillPlusSquareFill } from "react-icons/bs";
import { IoSearchOutline } from "react-icons/io5";
import { VscInspect } from "react-icons/vsc";
import { IoIosArrowDown } from "react-icons/io";
// import { MdOutlineNotStarted } from "react-icons/md";
import { getSoftwareVersion } from "@/utils/api";
import { checkIsAdmin } from '@/utils/all_apis/authApi';
import { GiHamburgerMenu } from "react-icons/gi";
import SidebarMobile from '@/components/Layout/SidebarMobile'
import Link from "next/link"
import { IoClose } from "react-icons/io5";
// import { IoHomeOutline } from "react-icons/io5";
import { GoHome } from "react-icons/go";

import LogoutButton from '@/components/Login/LogoutButton';
// import { useNextStep } from 'nextstepjs';
import { useState, useEffect } from 'react';

import Dropdown from "./components/Dropdown";
import DropdownItem from "./components/DropdownItem";
import ProjectsDropdown from "./components/ProjectsDropdown";



// import Link from 'next/link';

const TopBar = ({collapsed, isLoggedInAsGuest, username}:any) => {
  // const { startNextStep } = useNextStep();
  const [isOpen, setIsOpen] = useState(false)
  const [version, setVersion] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);
  
  

  useEffect(() => {
    const handleBeforeInstallPrompt = (event: Event) => {
      event.preventDefault();
      setDeferredPrompt(event as BeforeInstallPromptEvent);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  // const { startNextStep, closeNextStep, currentTour, currentStep, setCurrentStep, isNextStepVisible } = useNextStep();

  useEffect(() => {
    const softwareVersion = getSoftwareVersion()
    setVersion(softwareVersion || '');
    const fetchAdminStatus = async () => {
      const adminStatus = await checkIsAdmin();
      setIsAdmin(adminStatus);
    };

    fetchAdminStatus();

  }, []);

  // const handleInstallClick = () => {
  //   if (deferredPrompt) {
  //     deferredPrompt.prompt();
  //     deferredPrompt.userChoice.then((choiceResult) => {
  //       if (choiceResult.outcome === 'accepted') {
  //         console.log('User accepted the install prompt');
  //       } else {
  //         console.log('User dismissed the install prompt');
  //       }
  //       setDeferredPrompt(null);
  //     });
  //   }
  // };

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
          // Navigate to the installed app
          window.location.href = '/';
        } else {
          console.log('User dismissed the install prompt');
        }
        setDeferredPrompt(null);
      });
    }
  };

  const handleOpenChangelog = () => {
    window.open('/changelog', '_blank');
  };

  const handleCloseMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  

  return (
    <>
    {isOpen &&
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center z-50" onClick={()=>setIsOpen(!isOpen)}>
        <div
          className="bg-white rounded-b-lg shadow-lg min-w-48 px-4 w-[40%] transform transition-transform duration-300 ease-out translate-y-[-20px] opacity-0 animate-slideIn"
          onClick={(e) => e.stopPropagation()}
        >
          <button className="absolute top-2 right-2 text-gray-600 hover:text-gray-800" onClick={()=>setIsOpen(!isOpen)}>X</button>
          <h2 className="text-xl text-gray-800 font-semibold p-4">Create Form</h2>
          <p className="p-4 text-gray-500">disabled</p>
        </div>
      </div>}
    <header className="hidden md:flex fixed z-10 top-0 left-0 right-0 flex items-center justify-between bg-zoho-topband h-[48px]">
      <div className={`flex items-center justify-left bg-zoho-sidebar-800 h-full transition-all duration-300 ${collapsed ? 'w-10 pl-2' : 'w-[200px] pl-4'}`}>
        <Link href={'/'}><div className={`flex items-center cursor-pointer ${collapsed ? 'pr-4' : 'pr-[100px]'}`}>
          <span className="text-lg text-white flex items-center"><VscInspect size={20} />{!collapsed && <>&nbsp;&nbsp;InfraQ {collapsed}</>}</span>
          {!collapsed && version && isAdmin && <span onClick={handleOpenChangelog} className="text-xs text-gray-400 ml-2">{version}</span>}
        </div></Link>
      </div>
      <div className="flex items-center flex-grow p-4  border-b border-zoho-sidebar-font-color h-[48px]">
        <div className="relative dropdown mr-4">
        <Link href={'/history'}><button className="flex items-center text-black" type="button">
            <PiClockClockwiseLight className="mr-2" size={20} />
          </button></Link>
        </div>
        <div className="relative">
          <div className="flex items-center bg-zoho-search border border-gray-300 rounded-l-lg rounded-r-lg">
            <button onClick={()=>alert('disabled')} className="flex items-center px-2 py-2 text-black rounded-l-lg border-r border-solid border-gray-300" type="button">
              <IoSearchOutline size={18} />
              <IoIosArrowDown className="text-blue-400" size={12} />
            </button>
            <input
              type="text"
              placeholder="Search ( / )"
              className="px-2 py-2 rounded-r-lg focus:outline-none w-[100px] lg:w-full bg-zoho-search text-sm"
              value={""}
              onChange={()=>alert('disabled')}
            />
          </div>
        </div>
        {/* <span className="hidden md:block"><LogoutButton isLoggedInAsGuest={isLoggedInAsGuest} /></span> */}
      </div>
      <div className="flex items-center pr-2">
        <Link className="flex justify-between items-center m-2 px-2 py-1 bg-start-tour hover:bg-start-tour-hover text-white cursor-pointer border border-white rounded-md" type="button" href="/">
          <GoHome className="w-5 h-5"/>
          &nbsp;<span className="items-center text-sm hidden lg:inline-block">Home</span>
        </Link>
        {/* <button id="step1" className="flex justify-between items-center m-2 px-2 py-1 bg-start-tour hover:bg-start-tour-hover text-white cursor-pointer border border-white rounded-md" type="button" onClick={handleStartTour}>
        <MdOutlineNotStarted className="w-5 h-5"/>
          &nbsp;<span className="items-center text-sm hidden lg:inline-block">Start Tour</span>
        </button> */}

        <button onClick={()=>setIsOpen(!isOpen)} className="p-2 text-black cursor-pointer" type="button">
          <BsFillPlusSquareFill className='text-zoho-green hover:text-zoho-green-hover' size={30}/>
        </button>
        {/* <div className="p-2 text-black cursor-pointer hover:text-gray-600">
          <Link href="/"><GoHome size={20} /></Link>
        </div> */}
        <button className="p-2 text-black cursor-pointer hover:text-gray-600" type="button">

          <Dropdown
            isMiddleAligned={true}
              trigger={
                <GoPeople size={18}/>
              }
          >
            <DropdownItem>
              <div className="flex items-center gap-2 text-gray-400 font-sm">
                Collab disabled
              </div>
            </DropdownItem>
          </Dropdown>
        </button>
        <button className="p-2 text-black cursor-pointer hover:text-gray-600" type="button">

          <Dropdown
              isMiddleAligned={true}
              trigger={
                <IoIosNotificationsOutline size={20} />
              }
          >
            <DropdownItem>
              <div className="flex items-center gap-2 text-gray-400 font-sm">
                No new notifications
              </div>
            </DropdownItem>
          </Dropdown>
        </button>
        <div className="p-2 text-black cursor-pointer hover:text-gray-600">
          <Link href="/settings"><IoSettingsOutline size={20} /></Link>
        </div>
        <div className="p-2 text-black cursor-pointer hover:text-gray-600">
          <Dropdown
              isRightAligned={true}
              trigger={
                <HiOutlineUserCircle size={24} />
              }
          >
            <DropdownItem onClick={()=>alert("disabled")}>
              <div className="flex items-center gap-2 text-gray-500 text-sm font-semibold font-sans">
                Hi {isLoggedInAsGuest? "Guest" : username}
              </div>
            </DropdownItem>
            <DropdownItem>
              <div className="flex items-center gap-2 text-gray-400 font-sm pl-2">
                <LogoutButton />
              </div>
            </DropdownItem>
          </Dropdown>
        </div>
        <button className="p-2 text-black cursor-pointer hover:text-gray-600" type="button">
          <ProjectsDropdown />
        </button>
      </div>
    </header>
    <div className="md:hidden">
      <header className="fixed z-10 top-0 left-0 right-0 flex items-center justify-between bg-zoho-topband h-[48px]">
      <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 text-black cursor-pointer">
        <span className="text-lg text-black flex items-center"><GiHamburgerMenu size={24} /></span>
      </button>

        <div className="flex items-center pr-2">
          {deferredPrompt && (
            <button className="py-1 px-2 mx-4 font-base text-white bg-blue-500 hover:bg-blue-600 rounded cursor-pointer" onClick={handleInstallClick}>
              Install App
            </button>
          )}
          <div className="p-2 bg-start-tour text-white rounded cursor-pointer">
            <Link href="/"><GoHome size={24} /></Link>
          </div>
          <button className="p-2 text-black cursor-pointer hover:text-gray-600" type="button">
            <Dropdown
              isMiddleAligned={true}
                trigger={
                  <GoPeople size={18}/>
                }
            >
              <DropdownItem>
                <div className="flex items-center gap-2 text-gray-400 font-sm">
                  Collab disabled
                </div>
              </DropdownItem>
            </Dropdown>
          </button>
          <button className="p-2 text-black cursor-pointer hover:text-gray-600" type="button">

            <Dropdown
                isMiddleAligned={true}
                trigger={
                  <IoIosNotificationsOutline size={20} />
                }
            >
              <DropdownItem>
                <div className="flex items-center gap-2 text-gray-400 font-sm">
                  No new notifications
                </div>
              </DropdownItem>
            </Dropdown>
          </button>
          <div className="p-2 text-black cursor-pointer hover:text-gray-600">
            <Link href="/settings"><IoSettingsOutline size={20} /></Link>
          </div>
          <div className="p-2 text-black cursor-pointer hover:text-gray-600">
            <Dropdown
                isRightAligned={true}
                trigger={
                  <HiOutlineUserCircle size={24} />
                }
            >
              <DropdownItem onClick={()=>alert("disabled")}>
                <div className="flex items-center gap-2 text-gray-500 text-sm font-semibold font-sans">
                  Hi {isLoggedInAsGuest? "Guest" : username}
                </div>
              </DropdownItem>
              <DropdownItem>
                <div className="flex items-center gap-2 text-gray-400 font-sm pl-2">
                  <LogoutButton />
                </div>
              </DropdownItem>
            </Dropdown>
          </div>
          <button className="p-2 text-black cursor-pointer hover:text-gray-600" type="button">
            <ProjectsDropdown />
          </button>
        </div>
      </header>
      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center z-[100]" onClick={handleCloseMobileMenu}>
          <div className="bg-zoho-sidebar w-full h-full transform transition-transform duration-300 ease-out translate-y-[-100%] opacity-0 animate-slideIn" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between p-4 gap-2">
              <span onClick={handleCloseMobileMenu} className="text-xl text-white font-semibold">Menu</span>
              <button className="text-white" onClick={handleCloseMobileMenu}><IoClose className="w-6 h-6 inline-block" /></button>
            </div>
            <div className="">
              <SidebarMobile key={"sidebarrefreshkey_mobile"} onClose={handleCloseMobileMenu} />
            </div>
          </div>
        </div>
      )}
    </div>
    </>
  );
};

export default TopBar;
